import React, { useState } from "react";
import "./photoGallery.css";

const imageUrls = [
  "../images/sub/bg1.avif",
  "../images/sub/bg2.jpeg",
  "../images/sub/bg3.jpeg",
  "../images/sub/bg4.jpeg",
  "../images/sub/bg5.jpeg",
  "../images/sub/bg6.jpeg",
  "../images/sub/bg7.jpeg",
  "../images/sub/residential.jpg",
  "../images/sub/commercial.jpg",
  "../images/sub/industrial.jpg",
  "../images/sub/gallery1.jpeg",
  "../images/sub/gallery2.jpeg",
  "../images/sub/gallery3.jpeg",
  "../images/sub/gallery4.jpeg",
  "../images/sub/gallery5.jpeg",
  "../images/sub/gallery6.jpeg",
  "../images/sub/gallery7.jpeg",
  "../images/sub/gallery8.jpeg",
  "../images/sub/gallery9.jpeg",
  "../images/sub/gallery10.jpeg",
  "../images/sub/gallery11.jpeg",
  "../images/sub/gallery12.jpeg",
  "../images/sub/gallery13.jpeg",
  "../images/sub/gallery14.jpeg",
  "../images/sub/gallery15.jpeg",
  "../images/sub/gallery16.jpeg",
  "../images/sub/gallery17.jpeg",
  "../images/sub/gallery18.jpeg",
  "../images/sub/gallery19.jpeg",
  "../images/sub/gallery20.jpeg",
  "../images/sub/gallery21.jpeg",
  "../images/sub/gallery22.jpeg",
  "../images/sub/gallery23.jpeg",
  "../images/sub/gallery24.jpeg",
  "../images/sub/gallery25.jpeg",
];

export default function PhotoGallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const updateMainImage = (index) => {
    setCurrentIndex(index);
    const activeThumbnail = document.querySelectorAll(".thumbnail")[index];
    activeThumbnail?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest", // <- Prevent vertical scroll
    });
  };

  const goToPrev = () => {
    updateMainImage((currentIndex - 1 + imageUrls.length) % imageUrls.length);
  };

  const goToNext = () => {
    updateMainImage((currentIndex + 1) % imageUrls.length);
  };

  return (
    <div className="gallery-container">
      <h1>Photo Gallery</h1>
      <div className="main-image-wrapper">
        <button className="nav-btn prev-btn" onClick={goToPrev}>
          &#10094;
        </button>
        <img src={imageUrls[currentIndex]} alt="Main" className="main-image" />
        <button className="nav-btn next-btn" onClick={goToNext}>
          &#10095;
        </button>
      </div>

      <div className="thumbnails">
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`Thumbnail ${index}`}
            className={`thumbnail ${currentIndex === index ? "active" : ""}`}
            onClick={() => updateMainImage(index)}
          />
        ))}
      </div>
    </div>
  );
}
